import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  namespace: 'LISTING_CONTENT',
  entryPoint: '/listing-contents',
  collectionName: 'listing_contents',
  querySearchListing: [
    ['name'],
    { order: { id: 'asc' } }
  ],
  successMessageCreate: 'Listing content created',
  successMessageUpdate: 'Listing content updated',
  successMessageDelete: 'Listing content deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/content/listing-content/triggers.js